import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { BARREL_SCOPE } from '@cli-constants/snapshots.js'
import { applyGeneratedFiles } from '@next-adapter/snapshots/apply/apply-generated-files.js'
import { renderBarrelFiles } from '@next-adapter/snapshots/barrels/render-barrel-files.js'

export async function applyBarrels(
  cwd: string,
  config: ResolvedBetterstartConfig,
  options: { force: boolean; acceptGenerated?: boolean; interactive: boolean }
) {
  return applyGeneratedFiles({
    cwd,
    config,
    scope: BARREL_SCOPE,
    schemaJson: { name: BARREL_SCOPE },
    generatedFiles: renderBarrelFiles(cwd, config),
    force: options.force,
    acceptGenerated: options.acceptGenerated,
    interactive: options.interactive
  })
}
